import * as React from "react";
import { Helmet } from "react-helmet";

interface HelmetCanonicalProps {
  url: string;
}

/**
 * @description
 * Wraps \<link rel="canonical" href={url} />
 * and \<meta property="og:url" content={url} />
 * inside a Helmet component from "react-helmet".
 *
 * Also removes trailing slash, and lowercases the pathname
 */
export const HelmetCanonical: React.FC<HelmetCanonicalProps> = ({
  url: initialUrl,
}) => {
  const parsedUrl = React.useMemo(() => {
    return new URL(initialUrl);
  }, [initialUrl]);

  const pathname = React.useMemo(() => {
    const pathname = parsedUrl.pathname.endsWith("/")
      ? parsedUrl.pathname.substring(0, parsedUrl.pathname.length - 1)
      : parsedUrl.pathname;

    return pathname.toLocaleLowerCase();
  }, [parsedUrl]);

  // Only use the friendly URL as canonical (without query string filters)
  const url = `${parsedUrl.origin}${pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};
